import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card file-manager-sidebar bg-white border-0 rounded-3 rounded-bottom-0" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "mb-0 list-unstyled file-subdown" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[11] || (_cache[11] = _createElementVNode("form", { class: "position-relative default-src-form mb-4 pb-1" }, [
          _createElementVNode("input", {
            type: "text",
            class: "form-control rounded-1",
            placeholder: "Search"
          }),
          _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18" }, " search ")
        ], -1)),
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/my-drive",
              class: "d-flex align-items-center text-decoration-none justify-content-between"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "d-flex align-items-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " inbox "),
                  _createElementVNode("span", { class: "fw-semibold" }, "My Drive")
                ], -1),
                _createElementVNode("span", null, "6", -1)
              ])),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/file-manager/assets",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Assets ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/file-manager/projects",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Projects ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/file-manager/personal",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Personal ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: "/apps/file-manager/applications",
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Applications ")
                  ])),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/documents",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2 text-success" }, " description ", -1),
                _createElementVNode("span", { class: "fw-medium" }, "Documents", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/media",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2 text-info" }, " perm_media ", -1),
                _createElementVNode("span", { class: "fw-medium" }, "Media", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/recents",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2 text-primary-div" }, " schedule ", -1),
                _createElementVNode("span", { class: "fw-medium" }, "Recents", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/important",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2 text-warning" }, " grade ", -1),
                _createElementVNode("span", { class: "fw-medium" }, "Important", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/spam",
              class: "d-flex align-items-center text-decoration-none justify-content-between"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "d-flex align-items-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2 text-primary" }, " report_gmailerrorred "),
                  _createElementVNode("span", { class: "fw-medium" }, "Spam")
                ], -1),
                _createElementVNode("span", null, "10", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: "/apps/file-manager/trash",
              class: "d-flex align-items-center text-decoration-none justify-content-between"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "d-flex align-items-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2 text-danger" }, " delete "),
                  _createElementVNode("span", { class: "fw-medium" }, "Trash")
                ], -1),
                _createElementVNode("span", null, "15", -1)
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card bg-white border-0 rounded-3 rounded-top-0 border-top mb-4" }, [
      _createElementVNode("div", { class: "card-body p-4" }, [
        _createElementVNode("h4", { class: "fs-15" }, "Storage Status"),
        _createElementVNode("span", { class: "fs-13 d-block mb-2" }, "% 50 GB used of 100 GB"),
        _createElementVNode("div", {
          class: "progress bg-primary bg-opacity-10",
          style: {"height":"4px"},
          role: "progressbar",
          "aria-label": "Primary example",
          "aria-valuenow": "50",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("div", {
            class: "progress-bar bg-primary",
            style: {"width":"50%","height":"4px"}
          })
        ])
      ])
    ], -1))
  ]))
}